"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorTransformCollection = void 0;
var list_1 = require("@devexpress/utils/lib/utils/list");
var ColorTransformCollection = (function () {
    function ColorTransformCollection(transforms) {
        if (transforms === void 0) { transforms = []; }
        this.transforms = transforms;
    }
    ColorTransformCollection.prototype.applyTransform = function (color) {
        for (var _i = 0, _a = this.transforms; _i < _a.length; _i++) {
            var transform = _a[_i];
            transform.applyTransform(color);
        }
        return color;
    };
    ColorTransformCollection.prototype.add = function (transf) {
        this.transforms.push(transf);
    };
    ColorTransformCollection.prototype.equals = function (obj) {
        return obj &&
            list_1.ListUtils.allOf2(this.transforms, obj.transforms, function (a, b) { return a.equals(b); });
    };
    ColorTransformCollection.prototype.clear = function () {
        this.transforms = [];
    };
    ColorTransformCollection.prototype.clone = function () {
        return new ColorTransformCollection(list_1.ListUtils.deepCopy(this.transforms));
    };
    return ColorTransformCollection;
}());
exports.ColorTransformCollection = ColorTransformCollection;
